export default "__VITE_ASSET__BCXVm8pY__"